module.exports = __webpack_public_path__ + "a8f8bea0500719cc76c8199eab599c82.png";